import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Radio } from "lucide-react";

/**
 * Global event feed ticker — shows the most recent cross-player events
 * without exposing private rival data. Refreshes every 60s.
 */
export default function GlobalFeedTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/feed?limit=6");
        if (!cancelled) setItems(data?.feed || []);
      } catch { /* ignore */ }
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!items || items.length === 0) {
    return (
      <div className="tactical-card" data-testid="global-feed-empty">
        <p className="tac-label flex items-center gap-2">
          <Radio className="w-3 h-3 text-blood" /> THE FIELD // QUIET
        </p>
        <p className="text-[0.65rem] text-muted-h mt-2 italic">
          The world holds its breath. Be the first to break it.
        </p>
      </div>
    );
  }

  return (
    <div className="tactical-card" data-testid="global-feed-ticker">
      <p className="tac-label flex items-center gap-2 mb-3">
        <Radio className="w-3 h-3 text-blood" /> THE FIELD // RECENT
      </p>
      <ul className="space-y-1.5" data-testid="global-feed-list">
        {items.map((it, i) => (
          <li key={i} className="text-xs text-bone leading-relaxed flex gap-2"
              data-testid={`global-feed-item-${i}`}>
            <span className="text-blood mt-1.5 shrink-0" style={{
              width: 4, height: 4, borderRadius: 2, display: "inline-block",
              backgroundColor: "currentColor", marginTop: 6,
            }} />
            <span className="italic">{it.message}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
